export const siteInfo = {
  name: "免费电影在线观看",
  shortName: "免费电影",
  slogan: "高清电影，免费在线看",
  description:
    "免费电影在线观看为您提供丰富多样的电影资源，涵盖最新热门影片和经典大片，支持在线播放，让您轻松享受高清电影体验。",
  email: "support@freemovie-demo.com",
  icp: "演示站点 · 内容均为示例数据，仅供视觉与交互验证",
  copyright: "© 2024 免费电影在线观看 · 本网站为演示项目",
};

export const homeTdk = {
  title: "免费电影在线观看 - 高清电影在线免费观看平台",
  description:
    "免费电影在线观看为您提供丰富多样的电影资源，涵盖最新热门影片和经典大片，支持在线播放，让您轻松享受高清电影体验。",
  keywords:
    "免费电影在线观看,在线观看电影,免费电影,高清电影,在线电影,电影资源,电影平台",
};

export const footerLinks = {
  quickNav: [
    { label: "首页", to: "/" },
    { label: "电影分类", to: "/category/动作" },
    { label: "搜索电影", to: "/search" },
    { label: "关于我们", to: "/about" },
  ],
};